import { render, staticRenderFns } from "./DwGoodsList.vue?vue&type=template&id=621eeb6a&scoped=true"
import script from "./DwGoodsList.vue?vue&type=script&lang=js"
export * from "./DwGoodsList.vue?vue&type=script&lang=js"
import style0 from "./DwGoodsList.vue?vue&type=style&index=0&id=621eeb6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621eeb6a",
  null
  
)

export default component.exports